import initAnimations from './initAnimation';

export default function getRelatedProducts() {
    if ($('#IsProductPage').length > 0 && $('#RelatedProductBlock').length == 0) {
        var productKey = $('#IsProductPage').val();

        $.ajax({
            type: "GET",
            url: "/umbraco/surface/RelatedProducts/GetRelatedProducts?productKeyString=" + productKey,
            success: function (data) {
                $('#ProductWrapper').append($(data));
                var relatedProductText = $('#CanBeInterested').val();
                $('.alert, .alert-info').append('<h2 class="related-products-title">' + relatedProductText + '</h2>');
            },
            error: function (data) { }
        });
    }
    initAnimations();
}